import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';

const ErrorMessage = ({ isError, message }) => {
  return (
    <div id="error-message-content" style={{ display: 'block' }}>
      <div id="error-message-icon">
        <img src={ErrorIcon} alt="error_icon" />
      </div>
      <div id="error-message-title">
        <span className="frg-body-font-23px">
          {message}
        </span>
      </div>
      <div className="clear" />
      <div id="error-message-message">
        <span className="frg-body-font-14px">
          {isError}
          <br />
        </span>
      </div>
    </div>
  );
};

ErrorMessage.propTypes = {
  isError: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};
export default ErrorMessage;
